<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img43.jpg"/></p>
<p class="chap"><a id="ch20"></a>ALGONQUIAN ANNIHILATION, 1645</p>
<p class="noindent"><span class="big">A</span>ny fair and balanced study of Virginia cannot but provoke admiration. A primitive democracy was established. Tobacco cultivation laid the foundation for a rich commercial culture. Yet, Virginia’s hard-won success had a dark side. Tobacco fortunes were built on the backs of black slaves, and the mass migration of whites slowly brought the Native American confederacy to the brink of extinction. In 1607, 24,000 Algonquians lived in the Chesapeake Basin. By 1669, through disease, forced starvation, ethnic cleansing, and direct military action, that number had been reduced to about 2,000. It seemed Native Americans had stepped onto the slippery slope to annihilation. If they resisted, as they did, sometimes violently, they died. If they gave in and accommodated the whites, they died.</p>
<p class="indent">The tide of European population never seemed to ebb. By the end of the century, the few Algonquians left alive were herded onto tiny reservations and ruthlessly compelled to stay there. <span class="color">(12-026, 12-027)</span></p>
<p class="image"><img alt="image" src="images/img44.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter020.vue?2e8c21b5